@if (data$ | async; as data) {
  <div class="grid grid-cols-2 gap-3">
    <app-details-view label="Grafika">
      @if (isNotNil(data.previewFile)) {
        <app-image-thumbnail>
          <img
            [ngSrc]="data.previewFile.url"
            [fill]="true"
            [alt]="data.previewFile.alt"
            class="object-contain" />
        </app-image-thumbnail>
      } @else {
        <app-image-thumbnail-unsupported />
      }
    </app-details-view>

    <app-details-view label="Nazwa">
      {{ data.name }}
    </app-details-view>

    <app-details-view label="Dostępna">
      <app-boolean [value]="data.isActive" />
    </app-details-view>

    <app-details-view label="Data utworzenia">
      <app-date-time [date]="data.createdAt" />
    </app-details-view>

    <div class="col-span-2">
      <app-details-view label="Opis">
        <app-summernote-html-preview [html]="data.description" />
      </app-details-view>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
